import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/VisionStrategy/components/SectionPitch/SectionPitch.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>

        <img
          className={cn('pitch__image')}
          src='/images/pages/Company/VisionAndStrategy/chart-01.svg'
          alt='Chart'
        />

        <p className={cn('pitch__description')}>
          We set up DFA in 2020 as a development from the SeaRates.com freight booking
          platform which was designed to help smaller cargo owners looking for spot rates,
          and for larger cargo owners who look for spot rates to make up that 10-15% of
          their overall freight spend that is not already committed on a contract logistics basis.
        </p>

      </div>
    </section>
  );
};

export default SectionPitch;